import React, { useEffect, useRef, useState } from "react"
import Body from "../../components/body/BodyPage"
import MainLinks from "../../components/navlinks/MainLinks"
import { useTranslation } from "react-i18next";
import CallParking from "../../components/topviews/accountsettings/CallParking";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import { MDBAlert, MDBBtn, MDBCol, MDBDatepicker, MDBIcon, MDBInput, MDBModalFooter, MDBRow, MDBScrollspy, MDBScrollspyLink, MDBSpinner, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";
import AccPhoneNumbers from "../../components/topviews/accountsettings/AccPhoneNumbers";
import { Controller, set, useForm } from "react-hook-form";
import SaveChanges from "../../components/topviews/saveCancel";
import { deleteMsTenant, getGlobalAccSettingsInfo, getMisc, UpdateAccPinCID } from "../../apiclients/streamsapi_bridge";
import TopMessage from "../../components/header/TopMessage";
import TopSuccess from "../../components/header/TopSuccess";
import TelephoneNumbers from "../../components/TelephoneNumbers";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router";
import AssignedNumberConference from "./AssignedNumberConference";
import { isFiveNineAccount } from "../Login";
import PopupLoader from "../popups/PopupLoader";
import { api_serverUrl } from "../../apiclients/apiurls";
import TabIDConstant from "../../apiclients/TabIDConstant";
function GlobalSettings() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { isEdited, setEdited } = useAdminContext();
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [existingUsers, setExistingUsers] = useState([]);
    const [existingGroups, setExistingGroups] = useState([]);
    const [existingMembers, setExistingMembers] = useState([]);
    const [basicActive, setBasicActive] = useState('tab1');
    const [rerender, setrerender] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [assignedNumbers, setassignedNumbers] = useState([]);
    const [conferenceNumber, setconferenceNumber] = useState([]);
    const isFive9Account = (JSON.parse(sessionStorage.getItem("admin_session"))?.isFive9Account === true) ?? false;
    const isPPLogin = (JSON.parse(sessionStorage.getItem("admin_session"))?.loggedInFromPP === true) ?? false;
    const isAccountLogin = (JSON.parse(sessionStorage.getItem("admin_session"))?.isAccountAdmin === true) ?? false;
    const isSuperAdmin = (JSON.parse(sessionStorage.getItem("admin_session"))?.isSuperAdmin === true) ?? false;
    const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
    // const [isFiveNineAcc, setisFiveNineAcc] = useState(false);
    const fiveNineacc = isFiveNineAccount();
    const [errorMessage, setErrorMessage] = useState("");
    const [deleteBtn, setDeleteBtn] = useState(false);
    const [delTenantPopUp, setDelTenantPopUp] = useState(false);
    const togglePopUp = ()=> setDelTenantPopUp(!delTenantPopUp)
    const {
        register,
        handleSubmit,
        formState,
        setValue,
        setError,
        setFocus,
        reset,
        getValues,
        watch,
        control,
        clearErrors,
        formState: { dirtyFields, isDirty, errors }
    } = useForm({
        defaultValues: {
            global_settings: {
                global_acc_settings: {
                    aa_settings: {
                        parking_timeout: 120
                    },
                    acc_cid: {
                        default_cid: "-1",
                        default_cid_name: "",
                        allow_shared: 1,
                        billing_phnum: "-1",
                        allow_shared_callerid: 0,
                        add_users: [],
                        add_groups: [],
                        remove_user_groups: []
                    },
                    five9_otg_code: "",
                    ass_num_five9: [],
                    unass_num_five9: [],
                    directory_tenant_id: "",
                    app_client_id: "",
                    client_secret_value: "",
                    client_secret_exp_date: ""
                }
            }
        }
    })


    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const section4 = useRef(null);
    const section5 = useRef(null);
    const section6 = useRef(null);

    const containerRef = useRef(null);

    async function getglobalAccSettings() {
        try {
            setIsloading(true);
            setInternalError(false);
            const response = await getGlobalAccSettingsInfo(JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
                TabIDConstant.GLOBAL_SETT_SETTINGS_SUBLINK
            );
            const rawData = await response.json();
            console.log("getAccPinAndCidDtls details :::::: " + JSON.stringify(rawData));
            if (response.status === 200) {
                setassignedNumbers(rawData.global_acc_settings?.ass_num_five9 ?? []);
                setDbPhoneNumbers(rawData.global_acc_settings?.ass_num_five9 ?? []);
                setconferenceNumber(rawData.global_acc_settings?.ass_cacb_phnnumbers ?? []);
                reset({
                    global_settings: {
                        global_acc_settings: {
                            aa_settings: {
                                parking_timeout: rawData.global_acc_settings?.aa_settings?.parking_timeout ?? 120,
                            },
                            acc_cid: {
                                default_cid: rawData.global_acc_settings?.acc_cid?.defaultcallerid ?? "-1",
                                default_cid_name: rawData.global_acc_settings?.acc_cid?.callerid_name ?? "",
                                allow_shared: rawData.global_acc_settings?.acc_cid?.allow_shared ?? 1,
                                billing_phnum: rawData.global_acc_settings?.acc_cid?.billingphnumber ?? "-1",
                                allow_shared_callerid: rawData.global_acc_settings?.acc_cid?.allow_shared_callerid ?? 0
                            },
                            five9_otg_code: rawData.global_acc_settings?.five9_otg_code ?? "",
                            ass_num_five9: [],
                            unass_num_five9: [],
                            directory_tenant_id: rawData.global_acc_settings?.directory_tenant_id ?? "",
                            app_client_id: rawData.global_acc_settings?.app_client_id ?? "",
                            client_secret_value: rawData.global_acc_settings?.client_secret_value ?? "",
                            client_secret_exp_date: rawData.global_acc_settings?.client_secret_exp_date ?? ""
                        }
                    }
                });
                setExistingUsers(rawData?.global_acc_settings?.acc_cid?.users ?? []);
                setExistingGroups(rawData?.global_acc_settings?.acc_cid?.groups ?? []);
                setExistingMembers([...rawData?.global_acc_settings?.acc_cid?.users, ...rawData?.global_acc_settings?.acc_cid?.groups]);
                setDeleteBtn(rawData?.global_acc_settings?.delete_tenant_btn_visible ?? false);
                // console.log(`rawData?.acc_cid?.allow_shared_callerid  is ::: ${rawData?.global_acc_settings?.acc_cid}`);

            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                console.log("bhewfwebfew fewufbewui")
                setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }
    }

    function closeSave(e) {
        console.log(`isDirty value is :::::: on close ${isDirty}`);
        reset();
    }
    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);
    const onSubmit = async (data) => {
        if (isDirty) {
            const modifiedData = prepareFinalJson(formState.dirtyFields, data);
            if (modifiedData.global_acc_settings?.acc_cid?.default_cid_name?.length > 0) {
                console.log("ejwhbnh")
                // modifiedData.global_acc_settings.accpin_cid.default_cid_name.default_cid_name = modifiedData?.global_acc_settings.accpin_cid?.default_cid_name?.default_cid_name.trim();
            }
            let update = {}
            console.log("fjen few iewoj " + JSON.stringify(modifiedData));
            if (Object.keys(modifiedData)?.length > 0) {
                update = {
                    reqid: 64,
                    siteid: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid,
                    global_settings: modifiedData.global_settings
                }
            }
            const msteamsKeys = ["directory_tenant_id", "app_client_id", "client_secret_value", "client_secret_exp_date"];
            const modifiedGlobAccKeys = Object.keys(modifiedData?.global_settings?.global_acc_settings || {});
            const hasMSTeamsChange = msteamsKeys.some(k => modifiedGlobAccKeys.includes(k));
            if (hasMSTeamsChange && update.global_settings?.global_acc_settings) {
              setIsloading(true);
              msteamsKeys.forEach(key => {
                update.global_settings.global_acc_settings[key] = data.global_settings?.global_acc_settings?.[key]?.trim();
              });
            }
            console.log("update vocemail operator team ::::: " + JSON.stringify(update));
            let saverep = await UpdateAccPinCID(update);
            console.log("vocemail operator:::::: " + saverep);
            let saverepeMsg = await saverep.json();
            console.log("response vocemail operator::::: " + JSON.stringify(saverepeMsg))

            if (saverepeMsg.status && saverepeMsg.status == "success") {
                setSuccessMessage(saverepeMsg.message)
                setrerender(true);

            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {
                        console.log(`err object in  UpdateAccPinCID is :::::: ${JSON.stringify(err)}`);
                        const paramName = err?.param_name;
                        const key = paramName?.substring(paramName.lastIndexOf(".") + 1); // Extract "default_cid"
                        setError(paramName, {
                            type: "server",
                            message: err.message,
                        });
                        console.log("fjewf " + paramName + " fewfe " + err.message + " fref" + key);
                        const fieldElement = document.querySelector(
                            `input[name="${paramName}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }

            }
            setIsloading(false);
        }
    }
    function prepareFinalJson(dirtyFields, data) {
        const modifiedData = {};


        function recurse(dirtyFields, data, modifiedData, path = "") {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    const currentPath = path ? `${path}.${field}` : field;

                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(
                            dirtyFields[field],
                            data[field],
                            modifiedData[field],
                            currentPath
                        );
                    } else if (
                        Array.isArray(data[field]) &&
                        Array.isArray(dirtyFields[field])
                    ) {
                        // General handling for other arrays
                        modifiedData[field] = data[field].filter(
                            (_, index) => dirtyFields[field][index]
                        );
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }
    function handleDelMsTeamTennantHelper() {
        setDelTenantPopUp(true);
    }
    async function handleDelMsTeamTennant() {
        try {
            let update = {
                reqid: 64,
                siteid: JSON.parse(
                    sessionStorage.getItem("admin_session")
                ).siteid
            }
            setIsloading(true);
            togglePopUp();
            let response = await deleteMsTenant(update);
            response = await response.json();
            setSuccessMessage(response.message)
            if (response.status === "success") {
                setValue("global_settings.global_acc_settings.directory_tenant_id", "", { shouldDirty: false });
                setValue("global_settings.global_acc_settings.app_client_id", "", { shouldDirty: false });
                setValue("global_settings.global_acc_settings.client_secret_value", "", { shouldDirty: false });
                setValue("global_settings.global_acc_settings.client_secret_exp_date", "", { shouldDirty: false });
                setSuccessMessage(response.message);
                setDeleteBtn(false);
            } else if (response.status === "failed") {
                setErrorMessage(response.message);
                setInternalError(true);
            } else {
                setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }
    }

    useEffect(() => {
        // setisFiveNineAcc(isFiveNineAccount());
        getFreePhoneNumbers();

    }, []);

    async function getFreePhoneNumbers() {
        let updates = {};
        console.log(sessionStorage.getItem("admin_session"));
        updates = {
            misc: ["freeDIDs_SMS"],
        };

        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            updates
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const basicInfo = await response.json();
        if (!basicInfo) {
            window.alert(`info with id  not found`);
            navigate("/");
        }

        setSourceNumber(
            basicInfo.misc.freeDIDs_SMS?.map((phnum) => phnum.phnumber)

        );
    }

    useEffect(() => {
        if (rerender) {
            getglobalAccSettings();
            setrerender(false);
        }

    }, [rerender]);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest(".sticky-top");
            if (stickyParent && lastLink.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);


    const [useragent, setUserAgent] = useState("");
    const [sourceNumber, setSourceNumber] = useState("");
    const [smsPhnumberDtlsRef, setSMSPhNumberDtlsRef] = useState([]);
    const [updatePHNum, setUpdatePHNum] = useState(false);
    const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
    const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
    const [isstreamsReq, setIsStreamsReq] = useState(false);
    const [dbPhoneNumbers, setDbPhoneNumbers] = useState([]);

    useEffect(() => {
        if (updatePHNum.length > 0 && updateNumbersExecuted) {
            addPhoneNumbers("ass_num_five9");
            setUpdateNumbersExecuted(false);
        }
    }, [updatePHNum, updateNumbersExecuted]);

    useEffect(() => {
        if (updatePHNum.length > 0 && deleteNumberFlag) {
            addPhoneNumbers("unass_num_five9");
            setDeleteNumberFlag(false);
        }
    }, [updatePHNum, deleteNumberFlag]);

    async function addPhoneNumbers(fieldName) {
        setIsloading(true);
        let update = {
            reqid: 64,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            global_settings: {
                global_acc_settings: {
                    [fieldName]: updatePHNum,
                }
            }
        };

        console.log(JSON.stringify(update));
        console.log(JSON.stringify(update));
        let saverep = await UpdateAccPinCID(update);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            if (fieldName === "ass_num_five9") {
                setassignedNumbers((prev) => [...prev, ...updatePHNum]);
                setDbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
                setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`);
            } else {
                const updateAddPHNum = assignedNumbers.filter(
                    (num) => !updatePHNum.includes(num)
                );
                setassignedNumbers(updateAddPHNum);
                setDbPhoneNumbers(updateAddPHNum);
                setSuccessMessage(
                    `Telephone Number ${updatePHNum} removed successfully.`
                );
            }
            getFreePhoneNumbers();
        } else {
            if (fieldName === "unass_num_five9") {
                const modifynum = assignedNumbers.filter((num) => !updatePHNum.includes(num));
                setassignedNumbers([...modifynum, ...updatePHNum]);
                setDbPhoneNumbers([...modifynum, ...updatePHNum]);
            }
            if (saverepeMsg.message?.errors) {
                if (
                    saverepeMsg.message?.errors[0].errors &&
                    saverepeMsg.message?.errors[0].errors.length > 0
                ) {
                    saverepeMsg.message?.errors[0].errors.forEach((err) => {
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();
                        }
                    });
                }
            }
        }
        setIsloading(false);
    }


    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={32}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t("GlobalSettings")}
                                        </h5>
                                    </div>

                                    <MDBTabs className='mb-3'>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                    </MDBTabs>

                                    <MDBTabsContent>
                                        <MDBTabsPane open={basicActive === 'tab1'}>

                                            <MDBRow>
                                                <MDBCol
                                                    size="2"
                                                    md="2"
                                                    lg="2"
                                                    sm="12"
                                                    className="col-sm-100 pr-0 leftTabs"
                                                >
                                                    <MDBScrollspy container={containerRef}>
                                                        {!fiveNineacc && (
                                                            <>
                                                                <MDBScrollspyLink targetRef={section1}>
                                                                    Call Parking
                                                                </MDBScrollspyLink>
                                                                <MDBScrollspyLink targetRef={section2}>
                                                                    Caller ID
                                                                </MDBScrollspyLink>
                                                            </>
                                                        )}

                                                        {isFive9Account && (isAccountLogin || isSuperAdmin) && (<>
                                                            <MDBScrollspyLink targetRef={section3}>
                                                                Contact Center Settings
                                                            </MDBScrollspyLink>
                                                            <MDBScrollspyLink targetRef={section4}>
                                                                Assign to Contact Center
                                                            </MDBScrollspyLink>
                                                        </>)}
                                                        {!fiveNineacc && (
                                                            <>
                                                                <MDBScrollspyLink targetRef={section5}>
                                                                    Connect Audio Conference Bridge
                                                                </MDBScrollspyLink>
                                                            </>
                                                        )}
                                                        {/* {!(fiveNineacc || isWholesaleAcc) && (
                                                            <MDBScrollspyLink targetRef={section6}>
                                                                Microsoft Teams
                                                            </MDBScrollspyLink>
                                                        )} */}
                                                    </MDBScrollspy>
                                                </MDBCol>

                                                <MDBCol
                                                    size="12"
                                                    md="10"
                                                    sm="12"
                                                    pr-0
                                                    className="col-sm-100 pr-0 leftTabContent"
                                                >
                                                    <div ref={containerRef} className="scrollspy-example" style={{ maxHeight: "100vh !important" }}>
                                                        {!fiveNineacc && (<>
                                                            <section ref={section1} id="section-1">
                                                                <div class="general-settings" style={{ paddingLeft: "10px" }}>Call Parking</div>
                                                                <CallParking setEdited={setEdited} setValues={setValue} register={register} watch={watch} errors={errors} />
                                                            </section>
                                                            </>)}
                                                            {!fiveNineacc && (<>
                                                            <div className="routing-border p-0"></div>
                                                            
                                                            
                                                            <section ref={section2} id="section-2">
                                                                <div class="general-settings mt-4" style={{ paddingLeft: "10px" }}>Caller ID</div>
                                                                <AccPhoneNumbers
                                                                    setValue={setValue}
                                                                    register={register}
                                                                    watch={watch}
                                                                    errors={errors}
                                                                    clearErrors={clearErrors}
                                                                    getValue={getValues}
                                                                    setError={setError}
                                                                    existingUsers={existingUsers}
                                                                    setExistingUsers={setExistingUsers}
                                                                    existingGroups={existingGroups}
                                                                    setExistingGroups={setExistingGroups}
                                                                    existingMembers={existingMembers}
                                                                    setExistingMembers={setExistingMembers}
                                                                />
                                                            </section>
                                                            </>)}
                                                        {isFive9Account && (isAccountLogin || isSuperAdmin) && (<>
                                                            
                                                            <section ref={section3} id="section-3">
                                                                <div class="general-settings" style={{ paddingLeft: "10px" }}>Contact Center Settings</div>
                                                                <div className={`add-numbermain  ${!isPPLogin ? "disabled-form cursor-notAllowed" : ""}`}>
                                                                    <div className="tel-numbers">OTG Code</div>
                                                                    <div className="w-30 me-4">
                                                                        <MDBInput className="otgcode" id="" {...register("global_settings.global_acc_settings.five9_otg_code", { required: "OTG Code is required" })} />
                                                                        {errors?.global_settings?.global_acc_settings?.five9_otg_code && (
                                                                            <p className="text-danger">{errors?.global_settings.global_acc_settings?.five9_otg_code.message}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </section>
                                                            <div className="routing-border"></div>
                                                            <section ref={section4} id="section-4">
                                                                <div class="general-settings" style={{ paddingLeft: "10px" }}>Assign to Contact Center</div>
                                                                <TelephoneNumbers
                                                                    savedPhoneNumbers={assignedNumbers}
                                                                    setSavedPhoneNumbers={setassignedNumbers}
                                                                    setSuccessMessage={setSuccessMessage}
                                                                    uniqueid={null}
                                                                    setUpdatePHNum={setUpdatePHNum}
                                                                    setUpdateNumbersExecuted={setUpdateNumbersExecuted}
                                                                    sourceNumber={sourceNumber}
                                                                    setDeleteNumberFlag={setDeleteNumberFlag}
                                                                    dbPhoneNumbers={dbPhoneNumbers}
                                                                />
                                                            </section>
                                                            <div className="routing-border p-0"></div>
                                                        </>)}
                                                        
                                                        {!fiveNineacc && (<>
                                                            <div className="routing-border p-0"></div>
                                                            <section ref={section5} id="section-5">
                                                                <div class="general-settings mt-4" style={{ paddingLeft: "10px" }}>Connect Audio Conference Bridge</div>
                                                                <AssignedNumberConference
                                                                    sourceNumber={sourceNumber}
                                                                    setSuccessMessage={setSuccessMessage}
                                                                    setIsloading={setIsloading}
                                                                    setError={setError}
                                                                    conferenceNumber={conferenceNumber}
                                                                />
                                                            </section>
                                                        </>)}


                                                        {/* {!(fiveNineacc || isWholesaleAcc) && (<>

                                                            <div className="routing-border p-0"></div>
                                                            <section ref={section6} id="section-6" style={{ marginBottom: "15rem" }}>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div>
                                                                        <div class="general-settings mt-4" style={{ paddingLeft: "10px" }}>
                                                                            Microsoft Teams
                                                                            <a className="text-primary ms-3 text-decoration-underline fw-500" style={{ fontSize: "13px" }}
                                                                                href={`${api_serverUrl}docs/pdfs/Microsoft_Teams_Help_Doc.pdf`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer">Help</a>
                                                                        </div>
                                                                    </div>
                                                                    {deleteBtn &&
                                                                        <MDBBtn color="danger" className="me-3" onClick={handleDelMsTeamTennantHelper}>
                                                                            <MDBIcon fas icon="trash" className="me-2" />
                                                                            Remove
                                                                        </MDBBtn>}
                                                                </div>


                                                                <div>
                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">
                                                                            Directory (tenant) ID *
                                                                        </div>
                                                                        <div className="w-30">
                                                                            <MDBInput id="" type="text" className="w-100" {...register("global_settings.global_acc_settings.directory_tenant_id")}
                                                                                onChange={(e) => {
                                                                                    setValue(`global_settings.global_acc_settings.directory_tenant_id`, e.target.value, { shouldDirty: true });
                                                                                    clearErrors("global_settings.global_acc_settings.directory_tenant_id");
                                                                                }}
                                                                            />
                                                                            {errors?.global_settings?.global_acc_settings?.directory_tenant_id && (
                                                                                <p className="text-danger">{errors?.global_settings.global_acc_settings?.directory_tenant_id.message}</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">
                                                                            Application (client) ID *
                                                                        </div>
                                                                        <div className="w-30">
                                                                            <MDBInput id="" type="text" className="w-100" {...register("global_settings.global_acc_settings.app_client_id")}
                                                                                onChange={(e) => {
                                                                                    setValue(`global_settings.global_acc_settings.app_client_id`, e.target.value, { shouldDirty: true });
                                                                                    clearErrors("global_settings.global_acc_settings.app_client_id");
                                                                                }}
                                                                            />
                                                                            {errors?.global_settings?.global_acc_settings?.app_client_id && (
                                                                                <p className="text-danger">{errors?.global_settings.global_acc_settings?.app_client_id.message}</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">
                                                                            Client secret value *
                                                                        </div>
                                                                        <div className="w-30">
                                                                            <MDBInput id="" type="text" className="w-100" {...register("global_settings.global_acc_settings.client_secret_value")}
                                                                                onChange={(e) => {
                                                                                    setValue(`global_settings.global_acc_settings.client_secret_value`, e.target.value, { shouldDirty: true });
                                                                                    clearErrors("global_settings.global_acc_settings.client_secret_value");
                                                                                }} />
                                                                            {errors?.global_settings?.global_acc_settings?.client_secret_value && (
                                                                                <p className="text-danger">{errors?.global_settings.global_acc_settings?.client_secret_value.message}</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">
                                                                            Client secret expiration date *
                                                                        </div>
                                                                        <div className="w-30">
                                                                            <Controller
                                                                                name="global_settings.global_acc_settings.client_secret_exp_date"
                                                                                control={control}
                                                                                render={({ field, fieldState }) => (
                                                                                    <div>
                                                                                        <MDBDatepicker
                                                                                            inline
                                                                                            value={field.value}
                                                                                            format="mm/dd/yyyy"
                                                                                            disablePast
                                                                                            onChange={(value) => { if (value !== "") { field.onChange(value) } }}
                                                                                            readonly
                                                                                        />
                                                                                        {fieldState.error && (
                                                                                            <p className="text-danger">{fieldState.error.message}</p>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </section>
                                                        </>)} */}
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>

                                        </MDBTabsPane>
                                    </MDBTabsContent>
                                </div>
                            </section>
                        </>
                    }
                />


            </>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner
                                size="sm"
                                role="status"
                                tag="span"
                                className="me-2"
                            />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {Object.keys(dirtyFields).length !== 0 && (
                <SaveChanges
                    onClose={closeSave}
                    isdirtyFields={isDirty}
                    onSave={(e) => {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                    }}
                />
            )}
            {successMessage && (
                <>
                    <TopSuccess>
                        <TopMessage successMessage={successMessage} />
                    </TopSuccess>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    { errorMessage || "Internal Server Error" }
                </MDBAlert>
            )}
            { delTenantPopUp &&
                <PopupLoader
                    title={t("DelMSTeams")}
                    content={
                      <>
                      <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                      <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                          <div>{t("DelMSTeamsWrng")}</div>
                      </div>
                      <MDBModalFooter className="mt-2 pb-0 px-0">
                        <MDBBtn color="secondary" onClick={togglePopUp}>
                            {t("cancel")}
                        </MDBBtn>
                        <MDBBtn onClick={(e) => handleDelMsTeamTennant(e)}>{t("remove")}</MDBBtn>
                    </MDBModalFooter>
                      </>
                    }
                    onShow={setDelTenantPopUp}
                    onClose={togglePopUp}
                />
            }

            <Tooltip
                anchorSelect=".otgcode"
                place="right"
                className="exampleTooltip"
                events={['click']}
            >
                <div className="tooltip-content">
                    <h5>The OTG code must contain:</h5>
                    <ul>
                        <li>Numeric characters only (0-9).</li>
                        <li>6 or 15 or 19 digits.</li>
                    </ul>
                    <hr />
                    <h5>The OTG code must not:</h5>
                    <ul>
                        <li>Be empty or duplicate.</li>
                        <li>Contain special characters.</li>
                        <li>Contain spaces.</li>
                    </ul>
                </div>
            </Tooltip>

            {/* <Tooltip
                id="my-tooltip-click"
            >

            </Tooltip> */}
        </React.Fragment>
    )
}

export default GlobalSettings
